import type { IntlKey } from 'locales';
import type { DateFilter, ProductFilter } from 'state/blotters/common/blotter.model';
import { FilterBlotterType } from 'state/blotters/trades/types/types';

export const blotterTypeFilters: FilterBlotterType[] = ['trades', 'products', 'dlpProducts'];
const dateFilters: DateFilter[] = ['today', 'yesterday', 'oneWeek', 'twoWeeks', 'oneMonth', 'sixMonths', 'oneYear'];

export const productFilters: ProductFilter[] = [
  'allProducts',
  'autocall',
  'reverseConvertible',
  'participation',
  'accumulator',
  'sharkfin',
  'creditLinkedNote',
  'fxDualCurrencyNote',
  'fixedRateNote',
  'floatingRateNote',
];

export const currencyFilters: string[] = [
  'AUD',
  'CAD',
  'CHF',
  'CNY',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HKD',
  'HUF',
  'ILS',
  'JPY',
  'MXN',
  'NOK',
  'NZD',
  'PLN',
  'RON',
  'RUB',
  'SEK',
  'SGD',
  'TRY',
  'USD',
  'ZAR',
];

const dateFiltersWithCustom: readonly DateFilter[] = ['custom', ...dateFilters];

export const availableDateFilters = (filter: DateFilter): readonly DateFilter[] =>
  filter === 'custom' ? dateFiltersWithCustom : dateFilters;

export function getDateFilterTranslationKey(filter: DateFilter): `blotter.filter.date.${string}` & IntlKey {
  return `blotter.filter.date.${filter}`;
}

export function getProductTranslationKey(product: ProductFilter): `blotter.filter.products.${string}` & IntlKey {
  return `blotter.filter.products.${product}`;
}
